module.exports = __webpack_public_path__ + "static/media/JustActMailers_10-13.43c2278f.jpeg";